/** Arabic for words every area uses. Check here before adding one to an area file. Proposed; pending native aviation review. */
const ar: Record<string, string> = {
  Save: "حفظ",
  Cancel: "إلغاء",
  Close: "إغلاق",
  Delete: "حذف",
  Edit: "تعديل",
  Add: "إضافة",
  Remove: "إزالة",
  Filter: "تصفية",
  Export: "تصدير",
  Import: "استيراد",
  Print: "طباعة",
  Back: "رجوع",
  Next: "التالي",
  Previous: "السابق",
  Done: "تم",
  Yes: "نعم",
  No: "لا",
  OK: "موافق",
  Apply: "تطبيق",
  Reset: "إعادة تعيين",
  Clear: "مسح",
  Refresh: "تحديث",
  Details: "التفاصيل",
  Status: "الحالة",
  Priority: "الأولوية",
  Severity: "الخطورة",
  Zone: "المنطقة",
  Asset: "الأصل",
  Assets: "الأصول",
  Owner: "المسؤول",
  Due: "الاستحقاق",
  Created: "تاريخ الإنشاء",
  Updated: "آخر تحديث",
  Date: "التاريخ",
  Time: "الوقت",
  Type: "النوع",
  Name: "الاسم",
  Description: "الوصف",
  Notes: "تعليقات",
  Total: "الإجمالي",
  None: "لا يوجد",
  All: "الكل",
  Open: "مفتوح",
  Closed: "مغلق",
  Overdue: "متأخر",
  Today: "اليوم",
  Yesterday: "أمس",
  "This week": "هذا الأسبوع",
  "This month": "هذا الشهر",
  "Loading…": "جارٍ التحميل…",
  "No results": "لا توجد نتائج",
  "Show more": "عرض المزيد",
  "Show less": "عرض أقل",
  View: "عرض",
  Download: "تنزيل",
  Upload: "رفع",
  Submit: "إرسال",
  Confirm: "تأكيد",
  Title: "العنوان",
  Category: "الفئة",
  Location: "الموقع الجغرافي",
  "Assigned to": "مُسنَد إلى",
  Evidence: "الأدلة",
  Record: "السجل",
  Source: "المصدر",
  Value: "القيمة",
  Target: "المستهدف",
  Actual: "الفعلي",
  Plan: "الخطة",
  Variance: "الانحراف",
  Trend: "الاتجاه",
  Year: "السنة",
  Month: "الشهر",
  Week: "الأسبوع",
  Day: "اليوم",
  Hours: "ساعات",
  Minutes: "دقائق",
  Ask: "اسأل",
  "Asking…": "جارٍ السؤال…",
  Question: "سؤال",
  Answer: "الإجابة",
  Reason: "السبب",
  Result: "النتيجة",
  Results: "النتائج",
  Summary: "الملخّص",

  /* rolling a window up to its title — the shared Card's own control */
  Minimise: "تصغير",
  /* the verb on a button, not the adjective on a work order */
  "Open@card": "افتح",
  "Minimise {name}": "تصغير {name}",
  "Open {name}": "فتح {name}",
};
export default ar;
